// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3CYyN","box":"WorkspacesBox_box__25S0K","node":"WorkspacesBox_node__2voWy"};